<template>
  <li class="heavy-pad projectrow">
    <GithubProjectCard :name="name" :number="number" :url="url" :uri="uri" />
    <div class="row-data">
      <p>
      {{description}}
        <br>
        <br>
        <span v-for="topic in topics" :key="topic.topic.id" >⇿ {{topic.topic.name}} <br></span>
      </p>
    </div>
  </li>
</template>

<script>
import GithubProjectCard from "./GithubProjectCard";
export default {
  name: "ProjectRow",
  components: {
    GithubProjectCard
  },
  props:{
      description:String,
      name:String,
      number:Number,
      url:String,
      topics:Array,
      uri:String
  }
};
</script>
<style lang="scss" scoped>
.row-data:nth-child(odd) {
  direction: rtl !important;
}
.projectrow {
  display: grid;
  padding-left: 3rem;
  padding-right: 3rem;
  grid-template-columns: 1fr 2fr;
  div {
    justify-self: flex-end;
    direction: ltr;
  }
  div p {
    max-width: 350px;
    text-align: justify;
  }
  div {
    align-items: right;
  }
}
span {
  color: gray;
}
.projectrow:nth-child(odd) {
  direction: rtl;
}

@media screen and (max-width: 720px) {
  .projectrow {
    div p {
      width: 70vw;
      overflow: hidden;
    }
  }
}
@media screen and (max-width: 1060px) {
  .projectrow {
    grid-template-columns: 1fr;
  }
  .projectrow:nth-child(even) {
    direction: rtl;
  }
  .projectrow:nth-child(odd) {
    direction: rtl;
  }
}
</style>

